let urlBase = 'https://www.navlegalnotaries.com/' // placeholder. updated at loadtime
export default {
  website: {
    '@context': 'http://schema.org',
    '@type': 'WebSite',
    name: 'NavLegal Notaries',
    // 'alternateName': 'An alternative name for your WebSite',
    url: urlBase
  },
  breadcrumbs: {
    '@context': 'http://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: []
  },
  organization: {
    '@context': 'http://schema.org',
    '@type': 'Organization',
    url: urlBase,
    logo: urlBase + 'static/logo.png',
    contactPoint: []
  }
}



// WEBPACK FOOTER //
// ./src/store/jsonld.js